
import { ImageInfo } from "../../actions/parts/types/parts";
import { SEGMENT_IMAGES_FOLDER_PATH } from "./addtocart.constants";
import { CanvasMetaData, Logo, SegmentMetadata } from "./types/Fabric";
import alertify from '../../../libs/alert'


export const validateLogo = (image: {
    logo: Logo, isLibraryImage: boolean, includeSrcFile: boolean, isLocalImage: boolean
}) => {
    const { logo, isLibraryImage, includeSrcFile, isLocalImage } = image;

    const _idAvailable = (!!logo._id)
    const idAvailable = isLocalImage || (!!logo.id)
    const libraryImage = !isLibraryImage || (!!logo.libraryImage)
    const srcFile = !includeSrcFile || (!!logo.src)

    return _idAvailable && idAvailable && libraryImage && srcFile && logo.height && logo.width && logo.repeatSize && logo.repeatType
}

export const validateSegment = (segment: SegmentMetadata) => {
    return segment._id && segment.length &&
        segment.logos && segment.logos.length &&
        segment.number && segment.numberOfUnits &&
        segment.partIcon && segment.position &&
        segment.width
}

export const validateCanvasMetadata = ({ metaData, serialized }: CanvasMetaData) => {
    return metaData && metaData.parts && metaData.parts.length &&
        metaData.sku && metaData.totalLength && metaData.width && serialized
}

export const validateFilePath = (args: { filePath?: string, includeSrcFile: boolean }) => {
    const { filePath, includeSrcFile } = args
    if (includeSrcFile) {
        if (!filePath || !filePath.startsWith(SEGMENT_IMAGES_FOLDER_PATH))
            return false
        const lastIndex = filePath.lastIndexOf('/')
        const fileName = filePath.substring(lastIndex)
        const fileNameSections = fileName.split('.')
        return fileNameSections && fileNameSections.length && 
        fileNameSections[0] && fileNameSections[0].length &&
        fileNameSections[1] && fileNameSections[1].length
    } else {
        return true
    }
}

export const validateFileName = (name:string)=>{
    const fileNameSections = name.split('.')
        return fileNameSections && fileNameSections.length && 
        fileNameSections[0] && fileNameSections[0].length &&
        fileNameSections[1] && fileNameSections[1].length &&
    fileNameSections[0] !== 'undefined'
}


export const validateFile = (file:File, isLibImage:boolean)=>{
    return file && file.name && (!isLibImage || (file as any).id)
}

export const validateLIbraryImages = (images:ImageInfo[])=>{
    const validImages = images.filter(image=>{
        console.log(image);
        return image.curResolution
        && image.file && image.file.name && image.height && image.image_id &&
        image.minResolution && image.partWidth && image.resolutionSetting &&
        image.scaleFactor && image.width && image.src 
    })

    if(validImages.length === 0){
        alertify.alert('Error', 'selection could not complete as files could not be read. Try with different images','')
    }else if(validImages.length<images.length){
        alertify.alert('Error', 'some files were dropped as they could not be read.','')
    }

    return validImages
}